import './App.css';
import { useContext } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './components/Login/Login';
import SessionContext from './context/SessionContext';
import Account from './components/Account/Account';
import Logout from './components/Logout/Logout';
import { isATBrand } from './utils/OrderUtils';
import { getAppConfig } from './config/config';

function App() {
  const pathBase = isATBrand() ? ':lang/customer/' : 'customer/';
  const sessionCtx = useContext(SessionContext);
  const { isLoggedIn } = sessionCtx;
  const config = getAppConfig();
  const orderIdRoute = config.brand === 'DSD'
    ? '/orders/:orderId/vouchers'
    : `${pathBase}order/:orderId`;

  return (
    <BrowserRouter>
      <Routes>
        <Route path={`${pathBase}order/logout`} element={<Logout />} />
        <Route path={`${pathBase}logout`} element={<Logout />} />
        <Route
          path={`${pathBase}order/login`}
          element={<Login isLoggedIn={isLoggedIn} />}
        />
        <Route
          path={`${pathBase}login`}
          element={<Login isLoggedIn={isLoggedIn} />}
        />
        <Route
          path={orderIdRoute}
          element={<Account isLoggedIn={isLoggedIn} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
